import { Injectable } from "@angular/core";
import { loadKey } from "./models/loadKey";
import { _BaseLoadingService } from "./_base-loading.service";
import { PageLockService } from "./page-lock.service";
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

// Screen-lock = page-lock (compositie: elke mutatie loopt óók door PageLockService, dus overlay +
// page-lock-knoppen doen automatisch mee) plus de tab-wissel-knoppen en de footer-terug-knop
// ([loadKey]="loadKey.screenLock"). Voor acties met een tussentijds-inconsistente toestand, zoals
// de twee-staps hoofdfoto-upload (photoMainUpload$): wegnavigeren zou de keten halverwege afbreken.
@Injectable({
    providedIn: 'root'
})
export class ScreenLockService
    extends _BaseLoadingService
{

    private readonly __pageLockService = injectRequired(PageLockService);

    locked$$ = this.isLoading$$;

    constructor() {
        super(
            loadKey.screenLock
        )
    }

    add(): void {
        this.__pageLockService.add();
        super._add();
    }

    // Geen eigen pageLock-aanroep: _addCount loopt via this.add() en telt dus al mee.
    addCount(value: number): void {
        super._addCount(value);
    }

    clear(): void {
        this.__pageLockService.clear();
        super._clear();
    }

    remove(): void {
        this.__pageLockService.remove();
        super._remove();
    }

    // Geen eigen pageLock-aanroep: _removeCount loopt via this.remove() en telt dus al mee.
    removeCount(value: number): void {
        super._removeCount(value);
    }

    reset(): void {
        this.__pageLockService.reset();
        super._clear();
    }

}
